
export enum PortionUnit {
    Gram = 'g',
    Milliliter = 'ml',
    Piece = 'pcs',
}
